import { render } from "./root.vue?vue&type=template&id=b506b7f8&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"

import "./root.vue?vue&type=style&index=0&id=b506b7f8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b506b7f8"]])

export default __exports__